import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBuildingSkyscraper,
  IconCaretDown,
  IconEdit,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
  IconTrolley,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { AvatarUtils } from "../../../common/ColorByName/AvatarUtils";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import EditDataView from "./EditDataView";

export const stripDiacritics = (str: string) =>
  str
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");

export const normalizeText = (str: string) =>
  stripDiacritics(str)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const camelCaseToNormalized = (key: string) =>
  normalizeText(key.replace(/([A-Z])/g, " $1"));

const DeliveryPayrollKttc = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<Department[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [dataBranchCode, setDataBranchCode] = useState<any[]>([]);
  const [idCn, setIdCn] = useState<string[]>([]);
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataDeliveryWork, setDataDeliveryWork] = useState<ComboboxItem[]>([]);
  console.log(dataDeliveryWork);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<{
    StartTime: string;
    EndTime: string;
    branchCode: string[];
    DeliveryWorkNames: string[];
  }>({
    StartTime:
      _searchJson && checkedPinSearch
        ? _searchJson?.StartTime
        : new Date(
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              1,
            ).getTime() +
              7 * 60 * 60 * 1000,
          ).toISOString(),
    EndTime:
      _searchJson && checkedPinSearch
        ? _searchJson?.EndTime
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    branchCode: _searchJson && checkedPinSearch ? _searchJson?.branchCode : [],
    DeliveryWorkNames:
      _searchJson && checkedPinSearch ? _searchJson?.DeliveryWorkNames : [],
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );
  const handleChangeSearchValue = (
    value: string | null | string[],
    key: string,
  ) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : 0 ? value : [],
    }));
  };

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const daeAttributeColumns = React.useMemo<MRT_ColumnDef<any>[]>(() => {
    const keys = new Set<string>();
    data.forEach((row: any) => {
      if (!row?.daeAttributes) return;
      try {
        Object.keys(JSON.parse(row.daeAttributes)).forEach((k) => keys.add(k));
      } catch {
        // ignore invalid daeAttributes JSON
      }
    });

    return Array.from(keys).map((key) => {
      const normalizedKey = camelCaseToNormalized(key);
      const matched = dataDeliveryWork.find(
        (item: any) => normalizeText(item.label ?? "") === normalizedKey,
      );
      const label = matched?.label ?? key;

      return {
        id: `daeAttributes.${key}`,
        header: label,
        size:
          Number(key.length) < 10
            ? Number(key.length) * 20
            : Number(key.length) * 15,
        accessorFn: (row: any) => {
          try {
            const attrs = row?.daeAttributes
              ? JSON.parse(row.daeAttributes)
              : null;
            return attrs?.[key] ?? null;
          } catch {
            return null;
          }
        },
        Cell: ({ cell }) => {
          const value = cell.getValue<any>();
          return value === null || value === undefined ? "" : value;
        },
      };
    });
  }, [data, dataDeliveryWork]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "ngayCt",
        header: "Ngày lập",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ngayPc",
        header: "Ngày phân công",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "maCn",
        header: "Mã chi nhánh",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Button
              variant="light"
              p="4px 8px"
              radius="xl"
              size="xs"
              color="violet"
              fw="bold"
            >
              {renderedCellValue}
            </Button>
          </>
        ),
      },
      {
        accessorKey: "tenBp",
        header: "Bộ phận giao hàng",
      },
      {
        accessorKey: "soCtGoc",
        header: "Số chứng từ gốc",
        Cell: ({ renderedCellValue, cell }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : "#21d01b"}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "maCt",
        header: "Số vận đơn",
        Cell: ({ renderedCellValue, cell }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : "#21d01b"}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "soHd",
        header: "Số giao dịch",
        Cell: ({ renderedCellValue, cell }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : "#21d01b"}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "daeEmployeeName",
        header: "Kỹ thuật thực hiện và đi giao",
        size: 250,
      },
      {
        accessorKey: "tenCn",
        header: "Đia chỉ nhận hàng",
      },
      {
        accessorKey: "dcGiao",
        header: "Đia chỉ giao hàng",
      },
      {
        accessorKey: "dcNhan",
        header: "Địa chỉ nhận",
      },
      {
        accessorKey: "ghiChuDh",
        header: "Ghi chú đơn hàng",
      },
      {
        accessorKey: "ghiChuGh",
        header: "Ghi chú giao hàng",
      },
      // {
      //   accessorKey: "noteByEmployee",
      //   header: "Ghi chú của nhân viên giao hàng",
      //   size: 275,
      // },
      {
        accessorKey: "tenKh",
        header: "Tên khách hàng",
      },
      {
        accessorKey: "telephoneNumber",
        header: "SĐT khách hàng",
      },
      {
        accessorKey: "distanceEstimated",
        header: "Số km",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value && value !== 0) return null;
          const distanceInKm = (Number(value) / 1000).toFixed(2);
          return `${distanceInKm} km`;
        },
      },
      {
        accessorKey: "modifiedDistance",
        header: "Số km (Đã sửa)",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value && value !== 0) return null;
          const distanceInKm = (Number(value) / 1000).toFixed(2);
          return `${distanceInKm} km`;
        },
      },
      {
        accessorKey: "deliveryWorkName",
        header: "Công Việc",
      },
      {
        accessorKey: "receptionTime",
        header: "Ngày tiếp nhận",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ngayGh",
        header: "Ngày giao hàng",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "arrivalTime",
        header: "Ngày đến nơi",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "completionTime",
        header: "Ngày hoàn thành",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "tgXuatKho",
        header: "Ngày giờ xuất kho",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "tetCompletionTime",
        header: "Ngày giờ ktkt",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ttGh",
        header: "Trạng thái đơn giao hàng",
        size: 225,
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={getColorStatus(renderedCellValue?.toString() ?? "")}
            radius={"sm"}
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "modifiedStatusName",
        header: "Trạng thái đơn giao hàng (Đã sửa)",
        size: 275,
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={getColorStatus(renderedCellValue?.toString() ?? "")}
            radius={"sm"}
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "tienGiuiXe",
        header: "Tiền gửi xe",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue !== null &&
            renderedCellValue !== "0" &&
            renderedCellValue !== 0
              ? `${formatCurrencyVND(Number(renderedCellValue))} VNĐ`
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "hinhThucTt",
        header: "Hình thức thanh toán",
        size: 200,
      },
      {
        accessorKey: "tongTienDonHang",
        header: "Tổng tiền đơn hàng",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue !== null &&
            renderedCellValue !== "0" &&
            renderedCellValue !== 0
              ? `${formatCurrencyVND(Number(renderedCellValue))} VNĐ`
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "tongTienDaThanhToan",
        header: "Đã thanh toán",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue !== null &&
            renderedCellValue !== "0" &&
            renderedCellValue !== 0
              ? `${formatCurrencyVND(Number(renderedCellValue))} VNĐ`
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "tongPhaiThanhToan",
        header: "Tổng phải thanh toán",
        size: 200,
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue !== null &&
            renderedCellValue !== "0" &&
            renderedCellValue !== 0
              ? `${formatCurrencyVND(Number(renderedCellValue))} VNĐ`
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "tinhLuong",
        header: "Tính lương",
        Cell: ({ renderedCellValue }: any) => (
          <span
            style={{
              color: renderedCellValue ? "green" : "red",
              backgroundColor: renderedCellValue ? "#e0ffe0" : "#ffe0e0",
              border: "1px solid",
              borderColor: renderedCellValue ? "green" : "red",
              padding: "2px 4px",
              borderRadius: "4px",
            }}
          >
            {renderedCellValue ? "Có" : "Không"}
          </span>
        ),
      },
      {
        accessorKey: "modifiedPayroll",
        header: "Tính lương (Đã sửa)",
        Cell: ({ renderedCellValue }: any) =>
          renderedCellValue !== null ? (
            <span
              style={{
                color: renderedCellValue ? "green" : "red",
                backgroundColor: renderedCellValue ? "#e0ffe0" : "#ffe0e0",
                border: "1px solid",
                borderColor: renderedCellValue ? "green" : "red",
                padding: "2px 4px",
                borderRadius: "4px",
              }}
            >
              {renderedCellValue ? "Có" : "Không"}
            </span>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "writeNumberOrder",
        header: "Số hóa đơn VAT",
      },
      {
        accessorKey: "codeKd",
        header: "Mã KD",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Button
              variant="light"
              p="4px 8px"
              radius="xl"
              size="xs"
              color="blue"
              fw="bold"
            >
              {renderedCellValue}
            </Button>
          </>
        ),
      },
      {
        accessorKey: "tenKd",
        header: "Tên kinh doanh",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <>
            <AvatarUtils
              value={renderedCellValue?.toString().split("-")[0] ?? ""}
            />
          </>
        ),
      },
      {
        accessorKey: "noteByManager",
        header: "Ghi chú quản lý",
      },
      ...daeAttributeColumns,
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 80,
        enableResizing: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Flex justify={"center"}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={async () => {
                  editItem(row.original);
                }}
              >
                <IconEdit size={"xs"} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [daeAttributeColumns],
  );
  function getColorStatus(value: string | null) {
    switch (value) {
      case "Đã phân công":
        return "lime";
      case "Lập đơn giao hàng":
        return "green";
      case "Đang giao hàng":
        return "teal";
      case "Đơn hàng giao chưa thành công do Khách hàng":
        return "blue";
      case "Đơn hàng giao chưa thành công do Hacom":
        return "indigo";
      case "Hàng đã giao":
        return "violet";
      case "Hủy phân công":
        return "red";
      case "Đã đến nơi":
        return "#2bdd66";
      case "Nối chuyến":
        return "yellow";
      case "Hủy đơn":
        return "#c91a25";
      case null:
      case "":
        return "rgba(0, 0, 0, 0)";
    }
  }

  const renderMultiSelectOptionInvCode: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>
        {dataInvCode.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Group>
  );

  const renderMultiSelectOptionBrachCide: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataBranchCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );

  const DataInvCode = async () => {
    try {
      const response = await repositoryPos.get(`/api/v1/TblDepartment/get-all`);
      if (response && response.httpStatusCode === 200) {
        const transformedData = response.data
          .filter((i: any) => i.deparmentCode && i.name)
          .map((item: any) => {
            return {
              value: item.deparmentCode,
              label: item.deparmentCode + " - " + item.name,
            };
          });
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataInvCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const DataBrachCode = async () => {
    try {
      const response = await repositoryPos.get(
        `api/v1/TblDmInventory/get-select-branch?auth=true`,
      );
      if (response && response.success) {
        const transformedData = response.data
          .filter((i: any) => i.att2 && i.text)
          .map((item: any) => ({
            value: item.att2,
            label: item.att2 + " - " + item.text,
            id: item.value,
          }));

        setDataBranchCode(transformedData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const fetchDataDeliveryWord = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmDeliveryWork/get-all",
    );

    if (res && res.success) {
      const data = res.data
        .filter(
          (i: any) => i.name && i.department && i.department.includes("4"),
        )
        .map((i: any) => ({
          label: i.name,
          value: i.name,
        }));

      setDataDeliveryWork(data);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (keySearch && keySearch.length > 0) {
      url += `&KeySearch=${keySearch.trim().toLowerCase()}`;
    }
    if (search.StartTime) {
      url += `&startDate=${search.StartTime}`;
    }
    if (search.branchCode && search.branchCode.length > 0) {
      search.branchCode.forEach((branchCode) => {
        url += `&MaCns=${branchCode}`;
      });
    }
    if (search.EndTime) {
      url += `&endDate=${search.EndTime}`;
    }
    if (search.DeliveryWorkNames && search?.DeliveryWorkNames?.length > 0) {
      search.DeliveryWorkNames.forEach((i) => {
        url += `&DeliveryWorkNames=${i}`;
      });
    }
    try {
      const response = await repositoryMdm.get(
        `/api/v1/VEmployeeDeliveryPayroll/get-list-cam${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
  };

  function editItem(data: any) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa tính lương giao vận thi công</Title>
        </>
      ),
      size: "auto",
      children: <EditDataView data={data} onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  const exportDataExcel = async () => {
    open();
    try {
      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;

      if (keySearch && keySearch.length > 0) {
        url += `&KeySearch=${keySearch.trim().toLowerCase()}`;
      }
      if (search.StartTime) {
        url += `&startDate=${search.StartTime}`;
      }
      if (search.branchCode && search.branchCode.length > 0) {
        search.branchCode.forEach((branchCode) => {
          url += `&MaCns=${branchCode}`;
        });
      }
      if (search.EndTime) {
        url += `&endDate=${search.EndTime}`;
      }
      if (search.DeliveryWorkNames && search?.DeliveryWorkNames?.length > 0) {
        search.DeliveryWorkNames.forEach((i) => {
          url += `&DeliveryWorkNames=${i}`;
        });
      }
      const baseUrl = `/api/v1/VEmployeeDeliveryPayroll/export-excel-cam${url}`;

      const _url = BASE_API_MDM + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        let filename = "bao_cao_thuc_hien_giao_van_thi_cong.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const getDataEmployee = async () => {
    const listBranchId = idCn.map((item) => `&ListBranchId=${item}`).join("");
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/get-list?Skip=0${listBranchId}&Take=200`,
    );

    if (res && res?.success) {
      setDataEmployeeSelect(
        res.data
          ?.filter(
            (item: any) =>
              item.id != null &&
              item.fullname != null &&
              item?.attribute1 === "1",
          )
          ?.map((item: any) => ({
            value: item.id?.toString(),
            label: `${item.code} - ${item.fullname}`,
          })),
      );
    }
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (145 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize, deleteViewStatus]);

  useEffect(() => {
    const filteredIds = dataBranchCode
      .filter((item) => search.branchCode.includes(item.value))
      .map((item) => item.id);

    setIdCn(filteredIds);
  }, [search.branchCode]);

  useEffect(() => {
    if (idCn && idCn.length > 0) {
      getDataEmployee();
    }
  }, [idCn]);

  useEffect(() => {
    fetchDataDeliveryWord();
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    rowCount,
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "soCtGoc"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.departmentId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <div ref={headerRef} style={{ width: "100%" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex wrap={"wrap"} justify={"space-between"} align={"center"}>
          <_breadcrumb></_breadcrumb>
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                // size="xs"
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Application</Menu.Label>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconX style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Đóng
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Flex>
        <Grid w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 6, md: 3, lg: 2, xl: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 3, lg: 2, xl: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.StartTime && search.StartTime.length > 0
                  ? new Date(search.StartTime)
                  : null
              }
              maxDate={
                search.EndTime && search.EndTime?.length > 0
                  ? new Date(search.EndTime)
                  : new Date()
              }
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearchValue(formatDateNotTimeZone(e), "StartTime");
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 3, lg: 2, xl: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.EndTime && search.EndTime.length > 0
                  ? new Date(search.EndTime)
                  : null
              }
              minDate={
                search.StartTime && search.StartTime?.length > 0
                  ? new Date(search.StartTime)
                  : undefined
              }
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearchValue(formatDateNotTimeZone(e), "EndTime");
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 3, lg: 2, xl: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              clearable
              searchable
              value={
                search?.branchCode && search?.branchCode?.length > 0
                  ? search?.branchCode
                  : []
              }
              data={dataBranchCode.map((x) => x.value)}
              leftSection={<IconBuildingSkyscraper size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value, "branchCode");
              }}
              renderOption={renderMultiSelectOptionBrachCide}
              onClick={() => {
                if (dataBranchCode.length === 0) {
                  DataBrachCode();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 3, lg: 2, xl: 2 }}>
            <MultiSelect
              placeholder="Công việc"
              leftSection={<IconTrolley color="#15aabf" />}
              data={dataDeliveryWork}
              value={
                search?.DeliveryWorkNames &&
                search?.DeliveryWorkNames?.length > 0
                  ? search?.DeliveryWorkNames
                  : []
              }
              clearable
              nothingFoundMessage="Không có dữ liệu !"
              onChange={(e) => handleChangeSearchValue(e, "DeliveryWorkNames")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 6, md: 3, lg: 2, xl: 2 }}>
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default DeliveryPayrollKttc;
type Department = {
  ngayCt: string;
  maCt: string;
  soCtGoc: string | null;
  maKh: string;
  tenKh: string;
  nhomKh: string;
  telephoneNumber: string;
  deptId: number | null;
  maBp: string | null;
  tenBp: string | null;
  soHd: string;
  ngayHd: string | null;
  dcNhan: string;
  deliveryDeptCode: string | null;
  deliveryDept: string | null;
  branchId: number;
  maCn: string;
  tenCn: string;
  tenDuong: string;
  tenPhuong: string;
  tenQuan: string;
  sourceType: number;
  dcGiao: string;
  ghiChuGh: string | null;
  ngayGh: string;
  ttGh: string;
  tTienDh: number | null;
  ttDh: string | null;
  trangThaiTt: string | null;
  ttTienMat: number | null;
  ttChuyenKhoan: number | null;
  tongTienTt: number | null;
  tgXuatKho: string;
  maNguoiGh: string;
  tenNguoiGh: string;
  tinhLuong: boolean;
  nguoiLaiXe: string | null;
  dienGiai: string | null;
  receptionTime: string;
  deliveryTime: string | null;
  arrivalTime: string | null;
  completionTime: string | null;
  writeNumberOrder: string | null;
  tetCompletionTime: string | null;
  distance: number;
  distanceTotal: number;
  tongPhaiThanhToan: number | null;
  tongTienDonHang: number | null;
  tongTienDaThanhToan: number | null;
};
